import { Group, Image, Stack, Text } from '@mantine/core'
import { TwContainer } from '@/lib/components/TwContainer'

export const StiSectionFive = () => {
	return (
		<section>
			<TwContainer className={'justify-center py-16 pt-32 gap-12'} column>
				<Group gap={0} justify={'space-around'}>
					<Stack className={'max-w-xl p-4'} gap={'xs'}>
						<Text variant={'gray'} ta={'left'}>
							At Wellview Care we are committed to providing comprehensive STI services in a supportive and confidential environment. Our experienced
							team is here to guide you through every step of the process, from testing to counseling and beyond. Your sexual health matters, and
							we're here to help you take control of it.
						</Text>
					</Stack>
					<Image
						loading={'lazy'}
						className={'md:max-w-sm max-w-xs rounded-[32px]'}
						src={'/images/img_31.webp'}
						w={380}
						h={380}
						alt={'Sexually transmitted infections (STIs)'}
					/>
				</Group>
			</TwContainer>
		</section>
	)
}
